module.exports = __webpack_public_path__ + "static/media/button-edit.01cd59da.svg";